import { format } from 'date-fns';

/** "dd/MM/yyyy - <end>": the end is shortened to what differs from the start (day / day+month / full). */
export const formatRange = (startDate: Date | null, endDate: Date | null): string => {
    if (!startDate) return '';
    const startStr = format(startDate, 'dd/MM/yyyy');
    if (!endDate) return `${startStr} - `;
    const sameYear = startDate.getFullYear() === endDate.getFullYear();
    const sameMonth = sameYear && startDate.getMonth() === endDate.getMonth();
    const sameDay = sameMonth && startDate.getDate() === endDate.getDate();
    if (sameDay) return startStr;
    if (sameMonth) return `${startStr} - ${format(endDate, 'dd')}`;
    if (sameYear) return `${startStr} - ${format(endDate, 'dd/MM')}`;
    return `${startStr} - ${format(endDate, 'dd/MM/yyyy')}`;
};
